import * as React from 'react';
export const IcAntibacteria = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4 11h.4a5 5 0 001.06 1.6l.3.29-.47.46a1 1 0 00-.09 1.27l9.36-9.42a1 1 0 00-1.27.09l-.46.47-.29-.3a5 5 0 00-1.6-1.06v-.2a1.019 1.019 0 10-2-.4L9 4a5 5 0 00-2.74.83l-.53-.54a1.011 1.011 0 00-1.44 1.42l.54.53A5 5 0 004 9h-.2a1.005 1.005 0 00.2 2zm3-3a1 1 0 110 2 1 1 0 010-2zm12.8 5h-.2a5 5 0 00-1.06-1.6l-.3-.29.47-.46A1.005 1.005 0 0018 8.936a1.004 1.004 0 00-.71.294l-.46.47-.59-.59 4.47-4.46A1.005 1.005 0 0020 2.936a1.004 1.004 0 00-.71.294l-16 16a.999.999 0 000 1.42 1 1 0 001.42 0l4.46-4.47.59.59-.47.46a.999.999 0 000 1.42 1 1 0 001.42 0l.46-.47.29.3a5 5 0 001.6 1.06v.2A1 1 0 0013.8 21h.2a1 1 0 001-.8V20a5 5 0 002.74-.83l.53.54a1.002 1.002 0 001.639-.326 1 1 0 00-.219-1.094l-.54-.53A5 5 0 0020 15h.2a1.02 1.02 0 00-.4-2zM14 18a1 1 0 110-2.002A1 1 0 0114 18zm2-4a1 1 0 110-2.002A1 1 0 0116 14z'
      fill='currentColor'
    />
  </svg>
);
